import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import Table from '../../components/Table';
import TableHeader from '../../components/TableHeader';
import ModalCreateAdminAndLecturer from '../CreateLecturer/ModalCreateAdminAndLecturer';
import ButtonSetting from '../../components/ButtonSetting';
import ModalUpdateAdminAndLecturer from '../ModalUser/ModalUpdateAdminAndLecturer';
import ROLES from '../../../main/utils/roles';
import { ModalEducatorInvites } from '../ModalEducatorInvites';

export const columns = ({ openModalUpdateUser, role, locales }) => {
  const columnsArray = [
    {
      title: locales.admin.fullName,
      dataIndex: 'fullName',
      render: (fullName, row) => (
        <div>
          <p
            title={fullName || ''}
            className="overflow-hidden text-wrap"
            style={{ maxWidth: '350px' }}
          >
            {fullName && fullName.length > 200
              ? `${fullName.substring(0, 200)}...`
              : fullName || ''}
          </p>
          <p
            title={row.email || ''}
            className="overflow-hidden text-wrap"
            style={{ maxWidth: '350px' }}
          >
            {row.email && row.email.length > 200
              ? `${row.email.substring(0, 200)}...`
              : row.email || ''}
          </p>
        </div>
      ),
    },
    {
      title: locales.admin.type,
      dataIndex: 'role',
      render: (roleAtr, row) => {
        const style = {
          fontFamily: 'Nunito',
          fontSize: '16px',
          fontWeight: '400',
          lineHeight: '20px',
        };
        if (row.role === 'admin')
          return (
            <span
              style={{
                color: '#E91E63',
                ...style,
              }}
            >
              {locales.admin.admin}
            </span>
          );
        if (row.role === 'super_admin')
          return (
            <span
              style={{
                color: '#f37533',
                ...style,
              }}
            >
              {locales.admin.superAdmin}
            </span>
          );
        return (
          <span
            style={{
              color: '#00897B',
              ...style,
            }}
          >
            {locales.admin.educator}
          </span>
        );
      },
    },
    {
      title: locales.admin.class,
      dataIndex: 'classesCount',
      key: 'classesCount',
      render: (classCount) => classCount || 0,
    },
    {
      title: locales.admin.project,
      dataIndex: 'projectsCount',
      key: 'projectsCount',
      render: (projectsCount) => projectsCount || 0,
    },
    {
      title: locales.admin.student,
      dataIndex: 'studentsCount',
      key: 'studentsCount',
      render: (studentsCount) => studentsCount || 0,
    },
    {
      title: locales.admin.activeStudent,
      dataIndex: 'activeStudent',
      key: 'activeStudent',
      render: (activeStudent) => activeStudent || 0,
    },
    {
      title: locales.admin.totalTimeMin,
      dataIndex: 'totalTimeTracks',
      key: 'totalTimeTracks',
      render: (item) => item || 0,
    },
    {
      title: locales.admin.lastUpdated,
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (updatedAt) => {
        moment.locale('en');
        return moment(new Date(updatedAt)).format('DD MMM YYYY');
      },
    },
  ];
  if (role === ROLES.SUPER_ADMIN)
    columnsArray.push({
      title: '',
      key: 'action',
      render: (record) => (
        <ButtonSetting
          onClick={(event) => {
            event.stopPropagation();
            openModalUpdateUser(record.id, record?.classesCount);
          }}
        />
      ),
    });
  return columnsArray;
};

const AdminLecturerLists = ({
  byId,
  by,
  rowClick,
  rowClickable = false,
  locales,
}) => {
  const [search, setSearch] = useState(undefined);

  const [
    visibleModalCreateAdminAndLecturer,
    setVisibleModalCreateAdminAndLecturer,
  ] = useState(false);

  const [
    visibleModalUpdateAdminAndLecturer,
    setVisibleModalUpdateAdminAndLecturer,
  ] = useState(false);

  const [updateUserId, setUpdateUserId] = useState(null);

  const [visibleModalEducatorInvites, setVisibleModalEducatorInvites] =
    useState(false);

  const {
    adminLecturers: { data, meta, loading, uploading },
    pagination: { pageSize: initPageSize },
    user,
  } = useSelector((state) => state);

  const {
    adminLecturers: {
      fetchAdminLecturers,
      addUser,
      sortAdminLecturers,
      reload,
    },
  } = useDispatch();

  useEffect(() => {
    fetchAdminLecturers({ byId, by, search, limit: initPageSize });
  }, [byId, by, search, initPageSize]);

  const handleCloseModalCreateAdminAndLecturer = () => {
    setVisibleModalCreateAdminAndLecturer(false);
  };

  const handleOpenModalCreateAdminAndLecturer = () =>
    setVisibleModalCreateAdminAndLecturer(true);

  const handleCloseModalUpdateAdminAndLecturer = () => {
    setVisibleModalUpdateAdminAndLecturer(false);
    setUpdateUserId(null);
  };

  const handleOpenModalUpdateAdminAndLecturer = (userId) => {
    setVisibleModalUpdateAdminAndLecturer(true);
    setUpdateUserId(userId);
  };

  const handleCreateAdminAndLecturer = (values, afterSuccess) => {
    addUser({
      values,
      after: [handleCloseModalCreateAdminAndLecturer, afterSuccess],
    });
  };

  const handleOpenInviteModal = () => {
    setVisibleModalEducatorInvites(true);
  };

  const handleCloseInviteModal = () => {
    setVisibleModalEducatorInvites(false);
  };

  const isEstsablishmentSelected = () => {
    return by === 'establishments';
  };

  return (
    <>
      <ModalCreateAdminAndLecturer
        locales={locales}
        visible={visibleModalCreateAdminAndLecturer}
        onClose={handleCloseModalCreateAdminAndLecturer}
        onCreate={handleCreateAdminAndLecturer}
        uploading={uploading}
      />
      <ModalUpdateAdminAndLecturer
        visible={visibleModalUpdateAdminAndLecturer}
        onClose={handleCloseModalUpdateAdminAndLecturer}
        userId={updateUserId}
        param={{ byId, by, search, limit: initPageSize }}
        locales={locales}
        reload={reload}
        isAdminLecturerModal
      />
      <ModalEducatorInvites
        visible={visibleModalEducatorInvites}
        establishmentId={byId}
        onClose={handleCloseInviteModal}
      />
      <TableHeader
        title={locales.admin.adminEducator}
        count={loading ? <Spin /> : meta?.count || 0}
        onSearch={(searchValue) => {
          setSearch(searchValue);
        }}
        onCreate={handleOpenModalCreateAdminAndLecturer}
        textCreate={locales.admin.createNewAdminEducator}
        searchLoading={loading}
        onSecondaryCreate={() => {
          handleOpenInviteModal(true);
        }}
        textSecondaryCreate={locales.admin.inviteLinks}
        disableSecondaryCreate={!isEstsablishmentSelected()}
      />
      <Table
        columns={columns({
          openModalUpdateUser: handleOpenModalUpdateAdminAndLecturer,
          role: user?.current?.role,
          locales,
        })}
        dataSource={data}
        loading={loading}
        total={meta?.count || 0}
        current={meta?.page || 1}
        onChange={(pagination) => {
          const { current, pageSize } = pagination;
          fetchAdminLecturers({
            byId,
            by,
            search,
            page: current,
            limit: pageSize,
          });
        }}
        onRow={(record) => ({ onClick: () => rowClick(record) })}
        rowClickable={rowClickable}
        onSort={sortAdminLecturers}
        meta={meta}
      />
    </>
  );
};

AdminLecturerLists.propTypes = {
  byId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  by: PropTypes.oneOf(['users', 'establishments']),
  rowClick: PropTypes.func,
  rowClickable: PropTypes.bool,
};
export default AdminLecturerLists;
